// extracted by mini-css-extract-plugin
export default {"content":"DialogCloseWithChanges--content--2bd598"};